import { PropTypes } from "prop-types";
import TeamContextProvider from "./context/carousel/TeamCarouselContext";
import BlogCarouselContextProvider from "./context/carousel/BlogCarouselContext";
import QuoteContextProvider from "./context/carousel/QuoteCarouselContext";
import PopupContextProvider from "./context/others/PopupContext";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import LoadingProvider from "./context/LoadingContext";
import { TourProvider } from "./context/TourContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ExchangeRateProvider } from "./context/ExchangeRateContext";

/**
 * Application Providers
 * Wraps the app with all necessary context providers
 */
const Providers = ({ children }) => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ExchangeRateProvider>
          <LanguageProvider>
          <AuthProvider>
            <LoadingProvider>
              <TourProvider>
                <TeamContextProvider>
                  <BlogCarouselContextProvider>
                    <QuoteContextProvider>
                      <PopupContextProvider>{children}</PopupContextProvider>
                    </QuoteContextProvider>
                  </BlogCarouselContextProvider>
                </TeamContextProvider>
              </TourProvider>
            </LoadingProvider>
          </AuthProvider>
          </LanguageProvider>
        </ExchangeRateProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

Providers.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Providers;
